<div class="skeleton-loader">
  <div class="skeleton-section" *ngFor="let section of sections">
    <p-skeleton
      shape="rectangle"
      animation="none"
      [width]="section.width || '40%'"
      [height]="section.height || '24px'"
    ></p-skeleton>

    <p-skeleton
      *ngFor="let _ of [].constructor(section.rows || 0)"
      shape="rectangle"
      animation="none"
      [width]="section.width || '80%'"
      [height]="section.height || '16px'"
    ></p-skeleton>
  </div>
</div>
